module.exports = __webpack_public_path__ + "img/Romantikk_Litteraturen5.8ff6074d.jpg";